import styled from '@emotion/styled';

export default styled.p`
  display: block;
  padding: 10px 20px;
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: #00000080;
  border-top: 1px solid #00000019;
  border-bottom: 1px solid #00000019;
  background: #00000003;
`;
